import React from 'react';
import { useParams } from 'react-router-dom';
import TrainingResultsView from 'components/admin/result/TrainingResultsView';

const TrainingResults = () => {
  const { clubId, meetId } = useParams();

  return <TrainingResultsView clubId={clubId} meetId={meetId} />;
};

export default TrainingResults;
